import { React, useState, useEffect, useRef } from "react";
import bg_image from "../../../Assets/img/Personal_bg_image.png"
import { useLocation } from "react-router-dom";
import { Avatar, Box, Grid, IconButton, styled, Tab, Tabs } from '@mui/material'
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import GroupsIcon from '@mui/icons-material/Groups';
import CancelIcon from '@mui/icons-material/Cancel';
import { EmailRounded } from '@material-ui/icons';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
// import QrCodeProfile from "../MyProfileDetails/QrCodeProfile";

// Figma Icons
import CryptoJS from 'crypto-js';
import { ReactComponent as CalendarIcon } from "../../../Assets/img/icons/calendar-icon-figma.svg";
import { ReactComponent as SmallUserIcon } from "../../../Assets/img/icons/user-icon-figma.svg";
import { ReactComponent as GenderIcon } from "../../../Assets/img/icons/gender-neutral.svg";
// import { ReactComponent as MaleIcon } from "../../../Assets/img/icons/gender-male.svg";
// import { ReactComponent as FemaleIcon } from "../../../Assets/img/icons/gender-female.svg";
import { ReactComponent as SingleMaleIcon } from "../../../Assets/img/icons/single-male-figma.svg";
import { ReactComponent as SingleFemaleIcon } from "../../../Assets/img/icons/single-female-figma.svg";
import { ReactComponent as MarriedIcon } from "../../../Assets/img/icons/married-icon-figma.svg";
import { ReactComponent as AddressIcon } from "../../../Assets/img/icons/resume-location-icon.svg";
import { useMediaQuery } from "rsuite/esm/useMediaQuery/useMediaQuery";
import QrCodeProfile from "../MyProfileDetails/QrCodeProfile";

const PersonalProfileView = ({ personalData, isSectionPublic, isFieldPublic, connectionCount }) => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    let objectId = searchParams.get("objectId");
    const [bgImage, setBgImage] = useState(bg_image);
    const [activeMenu, setActiveMenu] = useState('my_profile');
    const handleMenuClick = (menu) => {
        setActiveMenu(menu);
    };

    console.log("personalData", personalData);
    const isSmallLaptop = useMediaQuery('(max-width:1200px)');
    const qrCodeSize = isSmallLaptop ? 80 : undefined;
    const encryptedUrlRef = useRef('');
    const userFullName = personalData.firstName + ' ' + personalData.lastName;

    const { hobbies, personalLanguages: languages } = personalData;

    // const tempDefaults = {
    //     aboutMe: 'When I began homeschooling, everything changed. Free to move as fast as I wanted, I devoured tomes from Jefferson, Hamilton, and Madison to London, Kipling, and Twain. I wrote 10-page papers on subjects from Ancient Sparta and military history to the founding of the United States and the resounding impact of slavery. I discovered more than I ever had, kindling a lifelong joy for learning.',
    //     hobbies: ['Learning Languages', 'Cooking', 'Singing', 'Song Translation'],
    //     languages: ['Tamil', 'Malayalam', 'Hindi', 'English'],
    // }

    const calculateAge = (dateOfBirth) => {
        const dob = new Date(dateOfBirth);
        const today = new Date();

        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();

        // If the current date is before the birthday this year, subtract 1 from the age
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            age--;
        }

        return age;
    }

    return (
        <>
            <div>
                <div className="my-profile-bg" style={{
                    backgroundImage: `url(${personalData.coverPic || bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}>

                    {/* <div className="My-Profile-Scanner-image">
                        <a
                            href={`${process.env.REACT_APP_CARD_URL}/digital-identity/Personal/${objectId}`}
                            target="_blank"
                            rel="noopener noreferrer"

                        >
                        <div className="profile-qr-container flex-center">
                            <QrCodeProfile className="container-gift-2"
                                size={95}
                                type="svg"
                            />
                        </div>
                        </a>
                    </div> */}

                    <div className="My-Profile-imgOutline flex-center">
                        {/* <img className="myprofilePhoto" src={profilePicturePersonal} alt="profile" /> */}
                        <div>
                            <Avatar sx={{ bgcolor: "#F4F7FE", width: "10rem", height: "10rem" }}>
                                {personalData.profilePic ?
                                    (
                                        <img src={personalData.profilePic} alt="profilepicture" className='profile-pic-avatar' />
                                    ) : (<>
                                        <InsertPhotoIcon sx={{ color: "grey" }} fontSize="large" />
                                    </>
                                    )}
                            </Avatar>
                        </div>
                    </div>

                    <div className="My-Profile-Scanner-image">
                        {/* <a
                                                href={`${process.env.REACT_APP_CARD_URL}/digital-identity/Personal/${objectId}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                    
                                            > */}
                        <div className="profile-qr-container flex-center">
                            <QrCodeProfile className="container-gift-2"
                                qrCodeUrl={`${process.env.REACT_APP_CARD_URL}/profile?encryptedId=${personalData?.encryptedId}`}
                                size={qrCodeSize}
                            />
                        </div>
                        {/* </a> */}
                    </div>

                </div>

                <div className="col sec-first second-part-of-Screen">
                    <div className="my-profile-heading-container">
                        <div className="my-profile-heading d-flex flex-column">
                            <span className="my-profile-heading name">{userFullName}</span>
                            {/* <span className="subheading mb-0">{userDetails.profession}</span> */}
                        </div>
                    </div>
                    <div className="my-profile-heading-content mt-1">
                        <div className="profile-meta-info ms-0">
                            <GroupsIcon /> <span className="color-blue">{connectionCount || 0} Connections</span>
                        </div>
                    </div>
                </div>

                <div className="p-3 pt-1">
                    <div className="menu mb-4">
                        <Tabs value={activeMenu} onChange={handleMenuClick} aria-label="Profile Tabs"
                            variant="scrollable"
                            scrollButtons="auto"
                            className='custom-profile-tabs'
                            selectionFollowsFocus
                        >
                            <Tab label='My Profile' value='my_profile' />
                            {/* <Tab label='Health' value='health' />
                            <Tab label='Family' value='family' /> */}
                        </Tabs>
                    </div>
                    <div className="shared-profile-view">
                        {(personalData.aboutMe && isSectionPublic.aboutMe) &&
                            <div className="about-me-personal">
                                <div className="form-display-title">
                                    <h2 className="headingforContent mb-0">About Me</h2>
                                </div>
                                <div className="text-left m-0 p-0 line-break">{personalData.aboutMe || ''}</div>
                            </div>
                        }

                        <div className="about-me-personal">
                            <div className="form-display-title">
                                <h2 className="headingforContent mb-0">Personal Information</h2>
                            </div>
                            <div className="personal-details">
                                <Grid container spacing={2}>
                                    {(personalData.dateOfBirth && isFieldPublic.dateOfBirth) &&
                                        <Grid item xs={6}>
                                            <div>
                                                <span className="span-center-align">
                                                    <CalendarIcon className="custom-icon" /> Age:{" "}
                                                </span>
                                                <div className="ms-1">{calculateAge(personalData.dateOfBirth)} Years Old</div>
                                            </div>
                                        </Grid>
                                    }
                                    {(personalData.phoneNumber && isFieldPublic.phoneNumber) &&
                                        <Grid item xs={6}>
                                            <div>
                                                <span className="span-center-align">
                                                    <CallRoundedIcon className="custom-icon" /> Phone Number:{" "}
                                                </span>
                                                <div className="ms-1">{personalData.phoneNumber}</div>
                                            </div>
                                        </Grid>
                                    }
                                    {(personalData.personalEmail && isFieldPublic.personalEmail) &&
                                        <Grid item xs={6}>
                                            <div>
                                                <span className="span-center-align">
                                                    <EmailRounded className="custom-icon" /> E-mail ID:{" "}
                                                </span>
                                                <div className="ms-1">{personalData.personalEmail}</div>
                                            </div>
                                        </Grid>
                                    }
                                    {(personalData.nickName && isFieldPublic.nickName) &&
                                        <Grid item xs={6}>
                                            <div>
                                                <span className="span-center-align">
                                                    <SmallUserIcon className="custom-icon" /> Nickname:{" "}
                                                </span>
                                                <div className="ms-1">{personalData.nickName}</div>
                                            </div>
                                        </Grid>
                                    }
                                    {(personalData.gender && personalData.gender !== "Prefer not to say" && isFieldPublic.gender) &&
                                        <Grid item xs={6}>
                                            <div>
                                                <span className="span-center-align">
                                                    <GenderIcon className="custom-icon" /> Gender:{" "}
                                                </span>
                                                <div className="ms-1">{personalData.gender}</div>
                                            </div>
                                        </Grid>
                                    }
                                    {(personalData.maritalStatus && isFieldPublic.maritalStatus) &&
                                        <Grid item xs={6}>
                                            <div>
                                                <span className="span-center-align">
                                                    {personalData.maritalStatus === 'Married' ? <MarriedIcon className="custom-icon" /> :
                                                        (personalData.gender === 'Female' ? <SingleFemaleIcon className="custom-icon" /> : <SingleMaleIcon className="custom-icon" />)
                                                    } Marital Status:{" "}
                                                </span>
                                                <div className="ms-1">{personalData.maritalStatus}</div>
                                            </div>
                                        </Grid>
                                    }
                                    {(personalData.personAddress && isFieldPublic.personAddress) &&
                                        <Grid item xs={12}>
                                            <div>
                                                <span className="span-center-align">
                                                    <AddressIcon className="custom-icon" /> Address:{" "}
                                                </span>
                                                <div className="ms-1">{personalData.personAddress}</div>
                                            </div>
                                        </Grid>
                                    }
                                </Grid>
                            </div>
                        </div>

                        {(hobbies.length > 0 && isSectionPublic.hobbies) &&
                            <div className="about-me-personal">
                                <div className="form-display-title">
                                    <h2 className="headingforContent mb-0">Personal Interests and Hobbies</h2>
                                </div>
                                <div className="skills-list-professional">
                                    {hobbies?.map((skill, index) => (
                                        <SkillItem key={index} label={skill} />
                                    ))}
                                </div>
                            </div>
                        }

                        {(languages.length > 0 && isSectionPublic.personalLanguages) &&
                            <div className="about-me-personal">
                                <div className="form-display-title">
                                    <h2 className="headingforContent mb-0">Languages</h2>
                                </div>
                                <div className="skills-list-professional">
                                    {languages?.map((skill, index) => (
                                        <SkillItem key={index} label={skill} />
                                    ))}
                                </div>
                            </div>
                        }


                    </div>
                </div>
            </div>
        </>
    )
}

const SkillBox = styled(Box)({
    border: "1px solid #D9D9D9",
    borderRadius: '16px',
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1px",
    margin: '5px 12px 5px 0px',
    height: '32px'
});

export function SkillItem({ label, isEdit, onAdd }) {

    return (
        <SkillBox>
            <div className="skill-item mx-3">{label}</div>
            <IconButton
                color='color-lightred'
                onClick={() => onAdd(label)}
                className='flex-center delete-icon-skills'
            >
                {isEdit ? <CancelIcon color="color-lightred" className="delete-icon-skills" /> : < ></>}
            </IconButton>
        </SkillBox>
    );
}

export default PersonalProfileView